import { QUERIES_PAGINATED, QUERIES_FIVE_W , QUERIES_SORT} from '../actions/types';

const formatQueriesForPagination = options => {
  const isArray = options.length ? true : false;
  if (isArray) {
    return options.slice(0, 10);
  } else {
    const { activeQueryPageNum, queries } = options;
    const end = activeQueryPageNum * 10;
    const start = end - 10;

    return queries ? queries.slice(start, end) : [];
  }
};

const noQueryData = [{
  keys: ['No queries found!']
}];

const sortQueryData = options => {
    const { querySortMetric, queryOrderDirection, queries } = options;
    if (queryOrderDirection === 'DESC') {
      return queries.sort(function(a, b) {
        if (querySortMetric === 'keys') {
          const pageA = a[querySortMetric][0];
          const pageB = b[querySortMetric][0];

          if (pageA > pageB) {
            return -1;
          }

          if (pageA < pageB) {
            return 1;
          }

          return 0;
        } else {
          return b[querySortMetric] - a[querySortMetric];
        }
      });
    }

    if (queryOrderDirection === 'ASC') {
      return queries.sort(function(a, b) {
        if (querySortMetric === 'keys') {
          const pageA = a[querySortMetric][0];
          const pageB = b[querySortMetric][0];

          if (pageA < pageB) {
            return -1;
          }

          if (pageA > pageB) {
            return 1;
          }

          return 0;
        } else {
          return a[querySortMetric] - b[querySortMetric];
        }
      });
    }

    return queries;
  }

export default function(state = [{
  keys: ['⬅ Select a page on the left table to begin']
}], action) {
  const options = action.payload;
  let paginatedRows, queryData;

  switch (action.type) {
    case QUERIES_PAGINATED:
    case QUERIES_FIVE_W:
      paginatedRows = formatQueriesForPagination(options);
      queryData = paginatedRows.length === 0 ? noQueryData : paginatedRows;

    return queryData || false;

    case QUERIES_SORT:
      const { activeQueryPageNum } = options
      const queriesSort = sortQueryData(options);
      paginatedRows = formatQueriesForPagination({ queries: queriesSort, activeQueryPageNum });
      queryData = paginatedRows.length === 0 ? noQueryData : paginatedRows;

      return queryData || false;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/queriesPaginatedReducer.js